import { useContext, useState } from 'react';
import { toaster } from 'baseui/toast';
import Router from 'next/router';
import { requestMatch } from '@gtintel/platform-api';
import { Button } from '@gtintel/platform-atoms';
import { useAsyncOp } from '@gtintel/platform-utils';
import { ProjectContext } from '../../../ProjectApp/context';
import AltAskingCarlosSpinner from './AltLoading';
import AskingCarlosSpinner from './Loading';
const toastSuccessContent = <div style={{
  display: 'flex',
  alignItems: 'center'
}}>
    Match requested! You can find it in the Match Queue.
    <Button size="mini" kind="secondary" onClick={() => Router.push('/admin/quality/matching')}>
      Go now
    </Button>
  </div>;
const RequestMatchButton = () => {
  const {
    projectId,
    status
  } = useContext(ProjectContext);
  const [hasRequested, setHasRequested] = useState(false);
  const {
    isLoading,
    fn: requestNpMatch
  } = useAsyncOp(requestMatch);
  const shouldShowAlt = Math.random() < 0.001;
  const handleRequestMatch = async () => {
    try {
      await requestNpMatch(+projectId());
      toaster.info(toastSuccessContent, {
        autoHideDuration: 5000
      });
      setHasRequested(true);
    } catch (error) {
      toaster.negative('Failed to request a match: ' + error.data?.error);
    }
  };
  return <Button kind="primary" testId="request-match-button" loading={isLoading} disabled={isLoading || hasRequested || +status() > 3} onClick={handleRequestMatch} overrides={{
    Root: {
      style: () => ({
        fontSize: '14px'
      })
    },
    LoadingSpinner: {
      component: shouldShowAlt ? AltAskingCarlosSpinner : AskingCarlosSpinner
    }
  }}>
      {hasRequested ? 'Match Incoming!' : `Request a New Match`}
    </Button>;
};
export default RequestMatchButton;